var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":"https://hzwimspic-1251601690.image.myqcloud.com/47466840-89f9-11ea-9c15-a97bbaf00d97_size_80x60"}}),_c('p',[_vm._v("暂无数据")])])
}]

export { render, staticRenderFns }